import { Chips, Fact } from "./FactGrid"
import { BRIEF_COPY } from "./copy"

const DETAIL = "mt-2 text-[13px] leading-[1.6] font-medium whitespace-pre-line text-muted-foreground"

// The order's NSFW and trigger-warning answers (design SensitiveContent), each
// with what the customer said about it. Sent only for the answers the customer
// gave.
export default function SensitiveContent({ content }) {
  return (
    <dl className="flex flex-col gap-[14px]">
      {content.nsfw && (
        <Fact fact={{ label: BRIEF_COPY.nsfw, kind: "bool", value: true }}>
          {content.nsfwText && <div className={DETAIL}>{content.nsfwText}</div>}
        </Fact>
      )}
      {content.triggerWarning && (
        <Fact fact={{ label: BRIEF_COPY.triggerWarning, kind: "bool", value: true }}>
          {content.topics?.length > 0 && <Chips items={content.topics} className="mt-2" />}
          {content.triggerText && <div className={DETAIL}>{content.triggerText}</div>}
        </Fact>
      )}
    </dl>
  )
}
